<template>
    <ul class="filter" v-if="showFilters">
        <li class="filter__item" v-if="industryTagFacet.length > 0 && !hasPreselectedIndustry">
            <label for="industryTagFilter" class="sr-only">{{ dictionary.IndustryDefaultTag }}</label>
            <select id="industryTagFilter" class="filter__item-inner" v-model="industryTag" :disabled="isLoading">
                <option value="Industry">{{ dictionary.IndustryDefaultTag }}</option>
                <option v-for="tagItem in industryTagFacet" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="competenceTagFacet.length > 0 && !hasPreselectedCompetence">
            <label for="competenceTagFilter" class="sr-only">{{ dictionary.CompetenceDefaultTag }}</label>
            <select id="competenceTagFilter" class="filter__item-inner" v-model="competenceTag" :disabled="isLoading">
                <option value="Competence">{{ dictionary.CompetenceDefaultTag }}</option>
                <option v-for="tagItem in competenceTagFacet" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="productTypeFacet.length > 0 && !hasPreselectedProduct">
            <label for="productTypeFilter" class="sr-only">{{ dictionary.ProductDefaultType }}</label>
            <select id="productTypeFilter" class="filter__item-inner" v-model="productType" :disabled="isLoading">
                <option value="ProductType">{{ dictionary.ProductDefaultType }}</option>
                <option v-for="tagItem in productTypeFacet" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item" v-if="businessFacet.length > 0">
            <label for="businessFilter" class="sr-only">{{ dictionary.BusinessDefaultType }}</label>
            <select id="businessFilter" class="filter__item-inner" v-model="business" :disabled="isLoading">
                <option value="Business">{{ dictionary.BusinessDefaultType }}</option>
                <option v-for="tagItem in businessFacet" :key="tagItem.Key" :value="tagItem.Key">{{
                    tagItem.Name
                }}</option>
            </select>
        </li>
        <li class="filter__item filter__item-reset" v-if="hasFilterApplied">
            <button type="button" @click="resetFilter">{{ dictionary.ResetArticles }}</button>
        </li>
    </ul>
    <ul class="articles-items">
        <li v-for="article in articles" :key="article.Url">
            <article class="article-item">
                <a :href="article.Url" :target="article.Target" class="article-item__link">
                    <div class="article-item__inner">
                        <div class="article-item__image">
                            <ResponsiveImage v-if="article.ImageForVue != null" :imageModel="article.ImageForVue" />
                            <div class="article-item__source" v-if="article.SourcepageLogo"><img
                                    :src="article.SourcepageLogo" alt="" /></div>
                        </div>
                        <div class="article-item__text">
                            <div class="article-item__customer" v-if="article.HasCustomerName">
                                {{ article.CustomerName }}
                            </div>
                            <h3 class="article-item__headline">{{ article.Headline }}</h3>
                        </div>
                        <div class="article-item__link-text">{{ dictionary.LatestArticlesLink }}</div>
                    </div>
                </a>
            </article>
        </li>
    </ul>
    <div class="articles-section__footer">
        <div class="articles-section__footer-load-more" v-show="hasMoreArticles">
            <a @click="getNextPage" :disabled="isLoading">{{
                dictionary.LoadMoreArticles
                }}</a>
        </div>
    </div>
</template>

<script>
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";

const serviceUrl = "/umbraco/api/casesapi/GetCases";
const defaultIndustryTag = "Industry";
const defaultCompetenceTag = "Competence";
const defaultProductType = "ProductType";
const defaultBusiness = "Business";

export default {
    name: "Cases",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            industryTagFacet: [],
            competenceTagFacet: [],
            productTypeFacet: [],
            businessFacet: [],
            culture: "da-DK",
            articles: [],
            pageSize: 9,
            page: 1,
            totalArticles: 0,
            isLoading: false,
            hasLoadedInitials: false,
            casesNodeIds: [],
            showFilters: false,
            isResetting: false,
            preselectedIndustry: [],
            hasPreselectedIndustry: false,
            preselectedCompetence: [],
            hasPreselectedCompetence: false,
            preselectedProduct: [],
            hasPreselectedProduct: false
        };
    },
    mixins: [
        bindRoute({
            industryTag: defaultIndustryTag,
            competenceTag: defaultCompetenceTag,
            productType: defaultProductType,
            business: defaultBusiness
        }),
    ],
    watch: {
        industryTag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        competenceTag: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        productType: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        },
        business: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal);
            }
        }
    },
    mounted() {
        this.casesNodeIds = this.$parent.casesNodeIds || [];
        this.pageSize = this.$parent.pageSize;
        this.showFilters = this.$parent.showFilters === "True";

        const preselectedIndustry = this.$parent.preselectedIndustry;
        if (Array.isArray(preselectedIndustry) && preselectedIndustry.length > 0) {
            this.hasPreselectedIndustry = true;
            this.preselectedIndustry = preselectedIndustry.map(tag => tag.toLowerCase());
            this.industryTag = this.preselectedIndustry[0]; // pick first, or loop if supporting multiple
        }
        const preselectedCompetence = this.$parent.preselectedCompetence;
        if (Array.isArray(preselectedCompetence) && preselectedCompetence.length > 0) {
            this.hasPreselectedCompetence = true;
            this.preselectedCompetence = preselectedCompetence.map(tag => tag.toLowerCase());
            this.competenceTag = this.preselectedCompetence[0]; // pick first, or loop if supporting multiple
        }

        const preselectedProduct = this.$parent.preselectedProduct;
        if (Array.isArray(preselectedProduct) && preselectedProduct.length > 0) {
            this.hasPreselectedProduct = true;
            this.preselectedProduct = preselectedProduct.map(tag => tag.toLowerCase());
            this.productType = this.preselectedProduct[0]; // pick first, or loop if supporting multiple
        }

        this.$router.isReady().then(() => {
            this.getInitialArticles();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged();
                }
            }
        },
        getCases(amountToSkip, pageSize) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");

            vm.toggleSpinner(true);

            const queryParams = new URLSearchParams();

            vm.casesNodeIds.forEach(id => {
                queryParams.append("casesNodeIds", id);
            });

            queryParams.append("languageCode", languageCode);
            queryParams.append("amountToSkip", amountToSkip);
            queryParams.append("pageSize", pageSize);

            if (Array.isArray(vm.preselectedIndustry) && vm.preselectedIndustry.length > 0) {
                vm.preselectedIndustry.forEach(tag => queryParams.append("industryTag", tag));

            } else if (vm.industryTag !== defaultIndustryTag) {
                queryParams.append("industryTag", vm.industryTag);
            }

            if (Array.isArray(vm.preselectedCompetence) && vm.preselectedCompetence.length > 0) {
                vm.preselectedIndustry.forEach(tag => queryParams.append("industryTag", tag));

            } else if (vm.competenceTag !== defaultCompetenceTag) {
                queryParams.append("competenceTag", vm.competenceTag);
            }

            if (Array.isArray(vm.preselectedProduct) && vm.preselectedProduct.length > 0) {
                vm.preselectedProduct.forEach(tag => queryParams.append("productType", tag));
            } else if (vm.productType !== defaultProductType) {
                queryParams.append("productType", vm.productType);
            }

            if (vm.business !== defaultBusiness) {
                queryParams.append("business", vm.business);
            }

            fetch(serviceUrl + "?" + queryParams.toString())
                .then((response) => response.json())
                .then((data) => {
                    vm.articles.push(...data.Items);
                    vm.industryTagFacet = data.Facets.IndustryTag;
                    vm.competenceTagFacet = data.Facets.CompetenceTag;
                    vm.productTypeFacet = data.Facets.ProductType;
                    vm.businessFacet = data.Facets.Business;
                    vm.dictionary = data.Dictionary;
                    vm.totalArticles = data.TotalItems;
                    vm.hasLoadedInitials = true;
                    vm.toggleSpinner(false);
                    vm.isResetting = false;
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                this.getCases(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialArticles() {
            const initialPageSize = this.pageSize * this.page;
            this.getCases(0, initialPageSize);
        },
        filterChanged() {
            this.articles = [];
            this.totalArticles = 0;
            this.page = 1;
            this.getCases(0, this.pageSize);
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.articles = [];
            vm.totalArticles = 0;
            vm.page = 1;
            vm.business = defaultBusiness;

            if (!vm.hasPreselectedIndustry) {
                vm.industryTag = defaultIndustryTag;
            }

            if (!vm.hasPreselectedCompetence) {
                vm.competenceTag = defaultCompetenceTag;
            }

            if (!vm.hasPreselectedProduct) {
                vm.productType = defaultProductType;
            }

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getCases(0, vm.pageSize);
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreArticles() {
            return (
                this.totalArticles !== 0 &&
                this.articles.length < this.totalArticles
            );
        },
        hasFilterApplied() {
            return this.industryTag !== defaultIndustryTag && !this.hasPreselectedIndustry ||
                this.competenceTag !== defaultCompetenceTag && !this.hasPreselectedCompetence ||
                this.productType !== defaultProductType && !this.hasPreselectedProduct ||
                this.business !== defaultBusiness;
        }
    },
};
</script>
